import type { ID } from '@octopus-do/octopus-project-core'
import {
  Archive as ArchiveIcon,
  Folder as FolderIcon,
} from '@octopus-do/octopus-storybook/icons'
import { getTitle } from '@store/reducers/dashboard/selectors'
import type { AppState } from '@store/types'
import type React from 'react'
import type { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'

import css from './styles.module.css'

interface HeaderOptions {
  archive: boolean
  workspaceId: ID
  folderId: ID
  // A fixed heading for sections that are not a folder (Templates). Without
  // it the title is the current workspace's or folder's name.
  title: string
}

type Props = Partial<HeaderOptions> & PropsWithChildren

export const ProjectsListHeader: React.FC<Props> = ({
  archive = false,
  workspaceId = '',
  folderId = '',
  title = '',
  children,
}) => {
  const folderTitle = useSelector<AppState, string | undefined>((state) =>
    getTitle(state, { workspaceId, folderId })
  )

  return (
    <div className={css.project_section}>
      <div className={css.title_wrap}>
        {folderId ? <FolderIcon /> : archive ? <ArchiveIcon /> : null}
        <span className={css.title}>{title || folderTitle}</span>
      </div>

      <div className={css.right_col}>{children}</div>
    </div>
  )
}
